/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button/new';
import { css } from '@atlaskit/css';
import CopyIcon from '@atlaskit/icon/core/copy';
import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { token } from '@atlaskit/tokens';

import {
	EmbedPreview,
	IconTile,
	type LinkEmbedVariantProps,
	messages,
	TitleMeta,
} from './link-embed-shared';

const containerStyles = css({
	width: '100%',
	boxSizing: 'border-box',
	backgroundColor: token('elevation.surface.sunken'),
	borderRadius: token('radius.large'),
	overflow: 'hidden',
	paddingTop: token('space.200'),
	paddingRight: token('space.200'),
	paddingBottom: token('space.200'),
	paddingLeft: token('space.200'),
});

const headerStyles = css({
	display: 'flex',
	alignItems: 'center',
	gap: token('space.150'),
	paddingLeft: token('space.100'),
	paddingRight: token('space.100'),
});

const actionsStyles = css({
	display: 'flex',
	gap: token('space.100'),
});

export const LinkEmbedFull = ({
	url,
	title,
	provider,
	iconUrl,
	previewHref,
	isError,
	modifiedBy,
	updatedDate,
	secondsAgo,
	isOlderThanWeek,
}: LinkEmbedVariantProps): JSX.Element => (
	<div css={containerStyles}>
		<div css={headerStyles}>
			<IconTile iconUrl={iconUrl} isError={isError} />
			<TitleMeta
				title={title}
				provider={provider}
				updatedDate={updatedDate}
				secondsAgo={secondsAgo}
				isOlderThanWeek={isOlderThanWeek}
				modifiedBy={modifiedBy}
			/>
			<div css={actionsStyles}>
				<Button
					appearance="default"
					iconAfter={LinkExternalIcon}
					onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
				>
					<FormattedMessage {...messages.open} />
				</Button>
				<Button
					appearance="default"
					iconAfter={CopyIcon}
					onClick={() => navigator.clipboard.writeText(url)}
				>
					<FormattedMessage {...messages.copy} />
				</Button>
			</div>
		</div>
		{!isError && <EmbedPreview url={url} previewHref={previewHref} />}
	</div>
);
